// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotal`
};

const el_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Μερικό υπόλοιπο`
};

const ru_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Подытог`
};

const he_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `סכום ביניים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const subtotal = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.subtotal(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("subtotal", locale)
	if (locale === "en") return en_subtotal(inputs)
	if (locale === "el") return el_subtotal(inputs)
	if (locale === "ru") return ru_subtotal(inputs)
	if (locale === "he") return he_subtotal(inputs)
	return "subtotal"
};